/**
 * 此处可直接引用自己项目封装好的 axios 配合后端联调
 */

import { post } from '@/utils/request' // 组件内部封装的axios
import { api, kapApi } from "@/utils/env";
// import request from "@/api/axios.js"       //调用项目封装的axios

// 获取验证图片  以及token
export function reqGet(data, source) {
  return post({
    url: (source === 'kapApi' ? kapApi + 'kapapi/' : api) + 'captcha/get',
    data
  })
}

// 滑动或者点选验证
export function reqCheck(data, source) {
  return post({
    url: (source === 'kapApi' ? kapApi + 'kapapi/' : api) + 'captcha/check',
    data
  })
}

